<template>
  <section  id="createAccount">
    <div>
      <h1 class="log__title">{{ $t("auth.account") }}</h1>
      <span class="log__text">
        {{ $t("auth.singIn") }}
      </span>
    </div>
    <b-form id="signUpForm" @submit.prevent="signUp">
      <b-row>
        <b-col md="6">
          <b-form-input
            type="text"
            v-model="user.first_name"
            required placeholder="First name"
            class="mb-3">
          </b-form-input>
        </b-col>
        <b-col md="6">
          <b-form-input
            type="text"
            v-model="user.last_name"
            required placeholder="Last name"
            class="mb-3">
          </b-form-input>
        </b-col>
      </b-row>
        <b-form-input
          v-if="userType != 'student'"
          type="text"
          v-model="user.school"
          required placeholder="School name"
          class="mb-3">
        </b-form-input>
      <b-form-input
        type="email"
        v-model="user.email"
        required placeholder="Enter email"
        :state="!errors.email"
        aria-describedby="inputEmailFeedback"
        class="mb-3">
      </b-form-input>
        <b-form-invalid-feedback>
          <span v-for="(error, index) in errors.email" :key="index">Email {{error}}</span>
        </b-form-invalid-feedback>
       <b-row>
          <b-col cols="12" sm="6">
            <b-form-input
              type="password"
              v-model="user.password"
              required placeholder="Password"
              :state="!errors.password"
              class="mb-3">
            </b-form-input>
            <b-form-invalid-feedback>
              <span v-for="(error, index) in errors.password" :key="index">
                Password {{error}}
              </span>
            </b-form-invalid-feedback>
          </b-col>
          <b-col>
            <b-form-input cols="12" sm="6"
              type="password"
              v-model="user.password_confirmation"
              required placeholder="Password confirmation"
              :state="!errors.password_confirmation"
              class="mb-3">
            </b-form-input>
             <b-form-invalid-feedback>
              <span v-for="(error, index) in errors.password_confirmation" :key="index">
                Password confirmation {{error}}
              </span>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      <b-row class="align-items-baseline">
        <b-col xl="5" lg="6" v-if="userType==='student'">
          <label class="text--black"> Date of birth </label>
          <date-selects @changeDate="setDate"></date-selects>
        </b-col>
        <b-col xl="7" lg="6">
          <b-form-group
            v-if="userType === 'student'"
            label="Unique Pin"
            label-for="dataInput"
            class="mt-3 mt-xl-0 mb-0">
            <b-form-input
              type="number" v-model="user.pin" required placeholder="Pin">
            </b-form-input>
          </b-form-group>
            <b-form-input v-if="userType !== 'student'"
              type="number"
              v-model="user.phone_number"
              :state="!errors.phone_number"
              required placeholder="Phone number">
            </b-form-input>
            <b-form-invalid-feedback>
              <span v-for="(error, index) in errors.phone_number" :key="index">
                Phone number {{error}}
              </span>
            </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-form-checkbox v-model="termsAccepted" value="automatic" class="mt-2">
        {{ $t("auth.terms") }}
      </b-form-checkbox>
      <b-row align-h="end">
        <b-col cols="12" lg="3" class="text-center mt-3">
          <b-btn variant="primary" size="sm" class="button--margin" type="submit"
            :disabled="!termsAccepted">
            Sign up
          </b-btn>
        </b-col>
      </b-row>
      <span v-if="success" class="log__succes">
        {{ $t("auth.alert") }}
      </span>
    </b-form>
  </section>
</template>

<script>
import auth from '@/api/v1/auth';
import DateSelects from '@/components/DateSelects';

export default {
  components: { DateSelects },
  props: ['userType'],
  data() {
    return {
      user: {},
      termsAccepted: false,
      errors: [],
      success: false,
    };
  },
  methods: {
    setDate(date) {
      this.user.date_of_birth = date;
    },
    signUp() {
      this.success = false;
      const succ = () => {
        this.errors = [];
        this.success = true;
      };
      const err = (error) => {
        if (error.response) {
          this.errors = error.response.data.errors;
        }
      };
      auth.signUp(this.userType, this.user, succ, err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Auth/Signup/Form.vue